import { setAppQuery } from './url';

// 是否在客户端内
export const isGrounds = !!window.grounds;

/**
 * @description 客户端关闭当前webview
 */
export const groundsClose = () => {
    if (isGrounds) {
        window.grounds.close();
    }
};

/**
 * @description 客户端打开分享托盘
 */
export const openAppShare = ({
    url = `${window.location.origin}${window.location.pathname}`,
    title = '',
    desc = '',
    thumbnail = '',
    documentId = '',
}) => {
    if (isGrounds) {
        const appQueryUrl = setAppQuery(url);

        window.grounds.openShare(appQueryUrl, title, desc, thumbnail, documentId);

        // if (window.grounds.newShare) {
        //     window.grounds.newShare(
        //         JSON.stringify({
        //             shareurl: appQueryUrl,
        //             title,
        //             desc,
        //             thumbnail,
        //             // 是否显示好友列表
        //             isShareFriends: true,
        //         }),
        //     );
        // } else {
        //     window.grounds.openShare(appQueryUrl, title, desc, thumbnail, documentId);
        // }
    }
};
